import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
export function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setIsAuthenticated(false);
      return;
    }
    // For demo purposes, we'll just check if the token exists
    // In a real app, you'd verify the token with a backend
    setIsAuthenticated(true);
  }, [navigate]);
  if (isAuthenticated === null) {
    // Still loading
    return <div className="flex items-center justify-center min-h-screen" data-id="element-180">
        <div className="w-16 h-16 border-t-4 border-amber-600 border-solid rounded-full animate-spin" data-id="element-181"></div>
      </div>;
  }
  if (isAuthenticated === false) {
    return <Navigate to="/admin/login" replace data-id="element-182" />;
  }
  return <>{children}</>;
}